// Kanal (müşteri nereden geldi) tanımları — panelin tamamında ortak kullanılır.
export const CHANNELS = {
  google_ads: { label: "Google Ads", color: "#2563EB", cls: "bg-blue-100 text-blue-800 border-blue-200" },
  meta_ads: { label: "Meta Reklam", color: "#7C3AED", cls: "bg-violet-100 text-violet-800 border-violet-200" },
  diger_reklam: { label: "Diğer Reklam", color: "#9333EA", cls: "bg-purple-100 text-purple-800 border-purple-200" },
  organik: { label: "Organik Arama", color: "#10B981", cls: "bg-emerald-100 text-emerald-800 border-emerald-200" },
  sosyal: { label: "Sosyal Medya", color: "#EC4899", cls: "bg-pink-100 text-pink-800 border-pink-200" },
  referans: { label: "Referans Site", color: "#06B6D4", cls: "bg-cyan-100 text-cyan-800 border-cyan-200" },
  direkt: { label: "Direkt Giriş", color: "#64748B", cls: "bg-slate-100 text-slate-700 border-slate-200" },
  telefon: { label: "Telefon (Çağrı)", color: "#F59E0B", cls: "bg-amber-100 text-amber-800 border-amber-200" },
  whatsapp: { label: "WhatsApp", color: "#22C55E", cls: "bg-green-100 text-green-800 border-green-200" },
  tavsiye: { label: "Tavsiye", color: "#F97316", cls: "bg-orange-100 text-orange-800 border-orange-200" },
  tekrar_musteri: { label: "Tekrar Müşteri", color: "#14B8A6", cls: "bg-teal-100 text-teal-800 border-teal-200" },
  bayi: { label: "Bayi / İş Ortağı", color: "#6366F1", cls: "bg-indigo-100 text-indigo-800 border-indigo-200" },
  diger: { label: "Diğer", color: "#94A3B8", cls: "bg-slate-100 text-slate-600 border-slate-200" },
  belirtilmemis: { label: "Belirtilmemiş", color: "#CBD5E1", cls: "bg-slate-50 text-slate-500 border-slate-200" },
};

// Panelden elle seçilebilen kanallar (servis kaydı açarken)
export const MANUAL_CHANNELS = [
  "telefon", "whatsapp", "google_ads", "organik", "direkt", "sosyal", "tavsiye", "tekrar_musteri", "bayi", "diger",
];

export const WEB_CHANNELS = ["google_ads", "meta_ads", "diger_reklam", "organik", "sosyal", "referans", "direkt"];

export const channelLabel = (c) => CHANNELS[c]?.label || c || "Belirtilmemiş";
export const channelColor = (c) => CHANNELS[c]?.color || "#94A3B8";

export const MESSAGE_STATUS = {
  yeni: { label: "Yeni", cls: "bg-blue-100 text-blue-800 border-blue-200", dot: "bg-blue-500" },
  okundu: { label: "Okundu", cls: "bg-slate-100 text-slate-700 border-slate-200", dot: "bg-slate-400" },
  donus_yapildi: { label: "Dönüş Yapıldı", cls: "bg-amber-100 text-amber-800 border-amber-200", dot: "bg-amber-500" },
  isleme_alindi: { label: "Servise Alındı", cls: "bg-emerald-100 text-emerald-800 border-emerald-200", dot: "bg-emerald-500" },
  kapandi: { label: "Kapandı", cls: "bg-zinc-100 text-zinc-600 border-zinc-200", dot: "bg-zinc-400" },
  spam: { label: "Spam", cls: "bg-rose-100 text-rose-700 border-rose-200", dot: "bg-rose-500" },
};

export const MESSAGE_TYPES = {
  servis_talebi: "Servis Talebi",
  bilgi: "Bilgi / Soru",
  sikayet: "Şikayet / Öneri",
  diger: "Diğer",
};

export const DEALER_STATUS = {
  yeni: { label: "Yeni", cls: "bg-blue-100 text-blue-800 border-blue-200" },
  inceleniyor: { label: "İnceleniyor", cls: "bg-amber-100 text-amber-800 border-amber-200" },
  gorusuldu: { label: "Görüşüldü", cls: "bg-indigo-100 text-indigo-800 border-indigo-200" },
  onaylandi: { label: "Onaylandı", cls: "bg-emerald-100 text-emerald-800 border-emerald-200" },
  reddedildi: { label: "Reddedildi", cls: "bg-rose-100 text-rose-700 border-rose-200" },
};

export const WARRANTY_STATUS = {
  acik: { label: "Açık", cls: "bg-blue-100 text-blue-800 border-blue-200" },
  inceleniyor: { label: "İnceleniyor", cls: "bg-amber-100 text-amber-800 border-amber-200" },
  serviste: { label: "Serviste", cls: "bg-indigo-100 text-indigo-800 border-indigo-200" },
  cozuldu: { label: "Çözüldü", cls: "bg-emerald-100 text-emerald-800 border-emerald-200" },
  reddedildi: { label: "Reddedildi", cls: "bg-rose-100 text-rose-700 border-rose-200" },
};

export function waLink(phone, text = "") {
  let d = (phone || "").replace(/\D/g, "");
  if (d.startsWith("0")) d = "90" + d.slice(1);
  else if (d.length === 10) d = "90" + d;
  return `https://wa.me/${d}${text ? `?text=${encodeURIComponent(text)}` : ""}`;
}

export function timeAgo(iso) {
  if (!iso) return "-";
  const s = Math.max(0, Math.floor((Date.now() - new Date(iso).getTime()) / 1000));
  if (s < 60) return "az önce";
  if (s < 3600) return `${Math.floor(s / 60)} dk önce`;
  if (s < 86400) return `${Math.floor(s / 3600)} sa önce`;
  if (s < 86400 * 30) return `${Math.floor(s / 86400)} gün önce`;
  return new Date(iso).toLocaleDateString("tr-TR");
}

export function fmtDuration(sec) {
  sec = Math.round(sec || 0);
  if (sec < 60) return `${sec} sn`;
  const m = Math.floor(sec / 60);
  if (m < 60) return `${m} dk ${sec % 60} sn`;
  return `${Math.floor(m / 60)} sa ${m % 60} dk`;
}
